import { render, staticRenderFns } from "./sertifikasi_kompetensi.vue?vue&type=template&id=5f9d32f2&"
import script from "./sertifikasi_kompetensi.vue?vue&type=script&lang=js&"
export * from "./sertifikasi_kompetensi.vue?vue&type=script&lang=js&"
import style0 from "./sertifikasi_kompetensi.vue?vue&type=style&index=0&id=5f9d32f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports